import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './SoftOpenFail.module.less';
import Dialog from '../Dialog/Dialog';
import { emptyOpenFailSoft, setOpenFailSoft } from '../../actions/layout';
import { downloadAddSoft } from '../../actions/downloadTask';
import { logging } from '../../actions/log';

const selectOpenFailSoft = createSelector(
  state => state.layout,
  layout => layout.openFailSoftInfo,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectIsEnabledSilent = createSelector(
  state => state.layout,
  layout => layout.isEnabledSilent,
);

const selectSilentInstSoft = createSelector(
  state => state.native,
  native => native.supportSilentInstSoft,
);

const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSofts,
);

export default memo(() => {
  const dispatch = useDispatch();
  const openFailSoft = useSelector(selectOpenFailSoft);
  const logInfoData = useSelector(selectLogInfo);
  const isEnabledSilent = useSelector(selectIsEnabledSilent); // 是否打开快速静默安装
  const [silentSoft, setSilentSoft] = useState(undefined);
  const silentInstSoft = useSelector(selectSilentInstSoft); // 支持快速静默安装的应用列表
  const [upgrade, setUpgrade] = useState(undefined);
  const upgradeSofts = useSelector(selectUpgradeSofts); // 可更新

  useEffect(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'Open_Redl',
        label: '',
        param2: {
          source: openFailSoft?.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: openFailSoft?.softID ?? openFailSoft?.SoftID ?? '',
        },
      }),
    );
  }, []);

  // 查询是否打开静默安装的开关
  // 查询当前是否已经安装 并且是否可升级
  useEffect(() => {
    if (silentInstSoft && isEnabledSilent) {
      setSilentSoft(silentInstSoft.find(soft_ => soft_.softID === openFailSoft.softID));
    }
  }, [openFailSoft, silentInstSoft, isEnabledSilent]);

  // 查询当前是否已经安装
  useEffect(() => {
    if (upgradeSofts) {
      setUpgrade(
        upgradeSofts.find(
          soft_ =>
            soft_.androidType !== '1' &&
            (soft_.softID === openFailSoft.softID || soft_.SoftID === openFailSoft.softID),
        ),
      );
    }
  }, [openFailSoft, upgradeSofts]);

  const handleDownload = () => {
    const logParam2 = {
      source: openFailSoft?.source,
      source_p: logInfoData.source_p,
      source_pp: logInfoData.source_pp,
      softid: openFailSoft?.softID ?? openFailSoft?.SoftID ?? '',
      softName: openFailSoft.softName,
      softType: 'o',
      url: openFailSoft?.downLoadUrl || openFailSoft?.downloadUrl,
      type: 'd',
    };
    // 获取静默安装参数
    let installparams = null;
    if (
      isEnabledSilent &&
      silentSoft &&
      silentSoft.softID === (openFailSoft.softID ?? openFailSoft.SoftID)
    ) {
      installparams = {};
      logParam2.type = upgrade ? 'xu' : 'xd';
      if (silentSoft.silentParamDic) {
        installparams.quiet = silentSoft.silentParamDic;
      }
      if (silentSoft.silentDirParamDic) {
        installparams.todir = silentSoft.silentDirParamDic;
      }
    }
    const softInfo = { ...openFailSoft, logInfo: logParam2, installparams };
    dispatch(
      logging({
        category: 'C',
        action: 'Open_Redl',
        label: '',
        param2: {
          softid: openFailSoft.softID ?? openFailSoft?.SoftID ?? '',
          source: openFailSoft?.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(downloadAddSoft(softInfo));
    dispatch(setOpenFailSoft({ isShow: false }));
  };

  return (
    <Dialog
      maskStyle={styles.open_fail_mask}
      containerStyle={styles.force_delete_open_fail}
      handleClose={() => dispatch(setOpenFailSoft({ isShow: false }))}
      title="温馨提示"
    >
      <div className={styles.message}>该应用已无法打开，建议您重新下载安装。</div>
      <div className={styles.btn_operation}>
        <div
          className={openFailSoft?.btnStyle ? styles.btn_create_b : styles.btn_create}
          onClick={handleDownload}
        >
          立即安装
        </div>
      </div>
    </Dialog>
  );
});
